import { render, staticRenderFns } from "./expedientesVencidos.vue?vue&type=template&id=7e71303d"
import script from "./expedientesVencidos.vue?vue&type=script&lang=js"
export * from "./expedientesVencidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports